import { render, staticRenderFns } from "./pay_by_card.vue?vue&type=template&id=5222704e&"
import script from "./pay_by_card.vue?vue&type=script&lang=js&"
export * from "./pay_by_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports